import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { TimeRangeTabs } from './TimeRangeTabs';

type Props = {
  total: number | undefined;
  searching: boolean;
  newestFirst: boolean;
  range: string;
  onSort: (newest: boolean) => void;
  onRange: (range: string) => void;
};

/** How many reports and in what order (a search can switch to newest first), with the time range on the right. */
export function ResultsBar({ total, searching, newestFirst, range, onSort, onRange }: Props) {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap', minHeight: 32 }}>
      <Typography variant="caption" aria-live="polite" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
        {total === undefined ? null : (
          <>
            <Box component="strong" sx={{ color: 'text.primary', fontWeight: 600 }}>{total.toLocaleString('en-SG')}</Box>
            {` ${total === 1 ? 'report' : 'reports'} · ${newestFirst ? 'newest first' : 'most relevant first'}`}
            {searching ? (
              <ButtonBase onClick={() => { onSort(!newestFirst); }} sx={sortSx}>
                {newestFirst ? 'Sort by relevance' : 'Sort by newest'}
              </ButtonBase>
            ) : null}
          </>
        )}
      </Typography>
      <TimeRangeTabs value={range} onChange={onRange} />
    </Stack>
  );
}

const sortSx = { ml: 1, fontSize: 'inherit', fontWeight: 600, color: 'primary.main', borderRadius: 0.5, px: 0.5, verticalAlign: 'baseline' } as const;
